const memberSocialType = {
    'google' : {name: '구글'},
    'apple' : {name: '애플'},
    'facebook' : {name: '페이스북'},
    'Wechat' : {name: '위챗'},
    'Email' : {name: '이메일'},
};

const memberSex = {
    0: {name: '남', detailName: '남자', childName: '남아'},
    1: {name: '여', detailName: '여자', childName: '여아'},
}

const memberUseStatus = {
    1: {name: '활동'},
    2: {name: '휴면'}
};

const memberAllowStatus = {
    0: {name: '승인대기'},
    1: {name: '승인완료'},
}

const memberType = {
    0: {name: '일반'},
    1: {name: '스페셜'},
    2: {name: '디렉터'},
    3: {name: '매니저'},
}

const curatorStatus = {
    0: {name: '대기'},
    1: {name: '승인'},
    2: {name: '거절'},
}
const curatorType = {
    1: {name: '일반'},
    2: {name: '큐레이터'},
    7: {name: '일반'},
    8: {name: '일반'},
}
const memberStatus = {
    1: {name: '활동'},
    2: {name: '휴면'},
}


export {memberType,curatorStatus,curatorType,memberStatus, memberUseStatus};
